import { call } from 'redux-saga/effects';

import { awaitNeedValue } from 'utils';

import * as selectors from '../selectors';

export const awaitOnboardingUpdated = () => {
  return call(awaitNeedValue, selectors.getOnboardingSteps, (value) => value);
};
